module.exports = __webpack_public_path__ + "media/applicants/in-store-shopper-5d4c01d0.webp";